import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";
import { getCompanyDropdownAction } from "../../../../../redux/actions/companiesActions";

const Company = ({ formik, modalData, updateModalState }) => {
  const dispatch = useDispatch();
  const { companyDropdownData } = useSelector(
    (state) => state.companyPagination,
  );
  const [openDropdown, setOpenDropdown] = useState(false);

  const inputValue = modalData?.company?.companyName || "";

  const addData = (item) => {
    updateModalState("company", item);
    setOpenDropdown(false);
  };

  useEffect(() => {
    if (openDropdown) {
      dispatch(getCompanyDropdownAction());
    }
  }, [openDropdown]);
  return (
    <>
      <div className="class-input">
        <div className="dropdown-input">
          <div className="input-box">
            <TextField
              sx={{
                "& input": {
                  fontSize: "12px",
                  marginRight: "32px",
                },
                marginTop: "24px",
                // marginBottom: "24px",
                // "& .MuiInputLabel-root.Mui-required:after": {
                //   content: '" *"',
                //   color: "red",
                //   fontSize: "12px",
                // },
              }}
              InputLabelProps={{
                style: { fontSize: "12px", color: "#3F3F3F" },
              }}
              fullWidth
              label="Şirkət"
              autoComplete="off"
              disabled
              value={inputValue}
              onBlur={() => formik.setFieldTouched("company", true)}
              required={false}
            />
            <DropdownIcon
              setOpenDropdown={setOpenDropdown}
              openDropdown={openDropdown}
            />
          </div>

          <ul
            className={`dropdown-body where-coming ${
              openDropdown ? "active" : ""
            }`}
          >
            {companyDropdownData?.map((company) => (
              <li key={company._id} onClick={() => addData(company)}>
                <h4>{company.companyName}</h4>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {formik.errors.company && formik.touched.company && (
        <small className="validation-err-message">
          {formik.errors.company}
        </small>
      )}
    </>
  );
};

export default Company;
